import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { fetchCancelledEventIds } from '../../api/events';
import { queryKeys } from '../../lib/query/queryKeys';
import { STALE } from '../../lib/query/staleTimes';

const EMPTY = new Set();

/**
 * The ids of upcoming cancelled events, as a Set — see api/events.fetchCancelledEventIds
 * for why the client has to ask separately.
 *
 * It returns an empty Set while loading and on error, so a failure here can never blank
 * the feed: the worst case is the pre-existing behaviour, a cancelled show left on screen.
 */
export function useCancelledEvents() {
  const { data } = useQuery({
    queryKey: queryKeys.events.cancelled(),
    queryFn: fetchCancelledEventIds,
    staleTime: STALE.semiStatic,
  });
  return useMemo(() => (data?.length ? new Set(data) : EMPTY), [data]);
}

/** Drop the cancelled rows from a list of feed-shaped events. */
export function withoutCancelled(rows, cancelled) {
  if (!cancelled?.size || !rows?.length) return rows;
  return rows.filter((row) => !cancelled.has(row.event_id));
}
